import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  container: {
    position: "relative",
    minHeight: ({ containerHeight }) =>
      `calc(${containerHeight}vw - 21.25rem - 80px)`,
  },
}));

export default useStyles;
